/**
 * I18N 插件
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import language from '@/assets/js/default-language.js';

const initI18nMessages = () => {
  const locales = require.context(
    './',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const keyName = matched[1];
      messages[keyName] = locales(key);
    }
  });
  return messages;
};

Vue.use(VueI18n);
Vue.locale = () => {
};
const locale = language();
localStorage.setItem('i18n', locale);

const i18n = new VueI18n({
  locale: locale,
  messages: initI18nMessages(),
  silentTranslationWarn: true
});

export default i18n;
